declare namespace $ {

	type $mol_button_minor__click_shm_hitalama_components_drafts_list_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_drafts_list['create'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_components_drafts_list_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_list__rows_shm_hitalama_components_drafts_list_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_drafts_list['rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_button_minor__attr_shm_hitalama_components_drafts_list_4 = $mol_type_enforce<
		({ 
			'selected': ReturnType< $shm_hitalama_components_drafts_list['current'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_button_minor__title_shm_hitalama_components_drafts_list_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_drafts_list['entry_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_components_drafts_list_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_drafts_list['choose'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_hitalama_components_drafts_list_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_components_drafts_list extends $shm_list_page {
		create( next?: any ): any
		Add_icon( ): $mol_icon_plus
		Add( ): $mol_button_minor
		add_buttons( ): readonly($mol_view)[]
		rows( ): readonly($mol_view)[]
		Entries( ): $mol_list
		current( id: any): boolean
		entry_title( id: any): string
		choose( id: any, next?: any ): any
		empty_label( ): string
		model( ): $shm_hitalama_components_drafts_model
		selected( next?: string ): string
		created( next?: any ): any
		opened( next?: any ): any
		title( ): string
		minimal_width( ): number
		add_content( ): ReturnType< $shm_hitalama_components_drafts_list['add_buttons'] >
		body( ): readonly(any)[]
		Entry( id: any): $mol_button_minor
		Empty( ): $mol_view
	}
	
}

//# sourceMappingURL=list.view.tree.d.ts.map